"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyTypeEnum = exports.KindOfPlaceEnum = void 0;
var KindOfPlaceEnum;
(function (KindOfPlaceEnum) {
    KindOfPlaceEnum[KindOfPlaceEnum["EntirePlace"] = 0] = "EntirePlace";
    KindOfPlaceEnum[KindOfPlaceEnum["PrivateRoom"] = 1] = "PrivateRoom";
    KindOfPlaceEnum[KindOfPlaceEnum["SharedRoom"] = 2] = "SharedRoom";
})(KindOfPlaceEnum = exports.KindOfPlaceEnum || (exports.KindOfPlaceEnum = {}));
var PropertyTypeEnum;
(function (PropertyTypeEnum) {
    PropertyTypeEnum[PropertyTypeEnum["Apartment"] = 0] = "Apartment";
    PropertyTypeEnum[PropertyTypeEnum["House"] = 1] = "House";
    PropertyTypeEnum[PropertyTypeEnum["SecondaryUnit"] = 2] = "SecondaryUnit";
    PropertyTypeEnum[PropertyTypeEnum["UniqueSpace"] = 3] = "UniqueSpace";
    PropertyTypeEnum[PropertyTypeEnum["Bed"] = 4] = "Bed";
    PropertyTypeEnum[PropertyTypeEnum["Hotel"] = 5] = "Hotel";
})(PropertyTypeEnum = exports.PropertyTypeEnum || (exports.PropertyTypeEnum = {}));
//# sourceMappingURL=schema.js.map